export default "__VITE_ASSET__ZzNvyVa5__"